function portableTextBlockText(block) {
    if (!Array.isArray(block?.children)) return ''

    return block.children
        .map((child) => (typeof child?.text === 'string' ? child.text : ''))
        .join('')
        .replace(/\s+/g, ' ')
        .trim()
}

export function articleBlockId(block) {
    return block?._key ? `article-${block._key}` : null
}

export function articleSectionId(section) {
    const explicitAnchor = section?.anchor?.current || section?.anchor
    if (explicitAnchor) return explicitAnchor
    return section?._key ? `article-${section._key}` : null
}

export function hasStructuredArticle(sections) {
    return Array.isArray(sections) && sections.some((section) => Array.isArray(section?.body))
}

// Посты на sections сами ставят карточку партнёра блоком articlePartnerCard. Карточку-оффер
// над статьёй глушили у всех таких постов, хотя у части из них своей карточки в начале нет:
// так молча не сработали записи SLUG_VERTICAL у parking-porto, doha-metro и ещё 6 постов.
// Дублем считаем только карточку в первых двух секциях — дальше она читателю уже не соседка.
export function hasEarlyPartnerCard(sections, depth = 2) {
    if (!hasStructuredArticle(sections)) return false
    return sections
        .slice(0, depth)
        .some((section) => Array.isArray(section?.body) && section.body.some((block) => block?._type === 'articlePartnerCard'))
}

export function flattenArticleBody(body, sections) {
    if (!hasStructuredArticle(sections)) return Array.isArray(body) ? body : []
    return sections.flatMap((section) => {
        const sectionBody = Array.isArray(section?.body) ? section.body : []
        if (!section?.title) return sectionBody

        return [
            {
                _key: `${section._key || 'section'}-heading`,
                _type: 'block',
                style: 'h2',
                children: [{ _type: 'span', text: section.title, marks: [] }],
            },
            ...sectionBody,
        ]
    })
}

export function getArticleNavigation(body, sections) {
    if (hasStructuredArticle(sections)) {
        return sections
            .filter((section) => section?.showInToc !== false && section?.title)
            .map((section) => ({
                id: articleSectionId(section),
                title: section.title,
            }))
            .filter((item) => item.id)
    }

    return (Array.isArray(body) ? body : [])
        .filter((block) => block?.style === 'h2')
        .map((block) => ({
            id: articleBlockId(block),
            title: portableTextBlockText(block),
        }))
        .filter((item) => item.id && item.title)
}
